import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Brand from "../pages/brand/page";
import EmailQuotePage from '../pages/email-quote/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/brand/:brandSlug",
    element: <Brand />,
  },
  {
    path: "/email-quote",
    element: <EmailQuotePage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
